/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createTheme } from "@mui/material/styles";
import { presetPalettes } from "@ant-design/colors";
// import lightBlue from '@mui/material/colors/lightBlue';
// import blue from '@mui/material/colors/blue';
// import green from '@mui/material/colors/green';
// import lightGreen from '@mui/material/colors/lightGreen';
// import teal from '@mui/material/colors/teal';
// import purple from '@mui/material/colors/purple';
import ThemeOption from "./theme";

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode) => {
    const colors = presetPalettes;

    const greyPrimary = [
        "#ffffff",
        "#fafafa",
        "#f5f5f5",
        "#f0f0f0",
        "#d9d9d9",
        "#bfbfbf",
        "#8c8c8c",
        "#595959",
        "#262626",
        "#141414",
        "#000000",
    ];
    const greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
    const greyConstant = ["#fafafb", "#e6ebf1"];

    colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

    const paletteColor = ThemeOption(colors);

    return createTheme({
        palette: {
            mode,
            common: {
                black: "#000",
                white: "#fff",
            },
            ...paletteColor,
            grey: {
                light: "#f5f5f5",
                main: "#bfbfbf",
                dark: "#595959",
                contrastText: "#000000",
            },
            text: {
                primary: paletteColor.grey[700],
                secondary: paletteColor.grey[500],
                disabled: paletteColor.grey[400],
            },
            action: {
                disabled: paletteColor.grey[300],
                main: "#078177",
                contrastText: "#FFFFFF",
                dark: "#00685E",
                light: "#219B91",
            },
            divider: paletteColor.grey[200],
            background: {
                paper: paletteColor.grey[0],
                default: paletteColor.grey.A50,
            },
            primary: {
                light: "#67e8f9",
                // main: '#00C1D5',
                main: "#0E7490",
                dark: "#0e7490",
                contrastText: "#FFFFFF",
            },
            warning: {
                light: "#fcd34d",
                main: "#f59e0b",
                dark: "#b45309",
                contrastText: "#FFFFFF",
            },
            danger: {
                light: "#e10000",
                main: "#C10000",
                dark: "#B70000",
                contrastText: "#FFFFFF",
            },

            // warning: '#f59e0b',
            secondary: {
                light: "#06b6d4",
                main: "#0e7490", // '#059669', // '#2563eb', // '#4338ca', // '#3730a3',
                // main: '#009AAA',  // '#4974a5', // '#006772',  //'#0055D5',
                dark: "#164e63", //'#004988',
                disabled: "#5b535d", //'#004988',
                contrastText: "#FFFFFF",
                background: "#F3F8F9",
            },
            accent: {
                light: "#c026d3",
                main: "#86198f", // '#059669', // '#2563eb', // '#4338ca', // '#3730a3',
                // main: '#009AAA',  // '#4974a5', // '#006772',  //'#0055D5',
                dark: "#4f1252", //'#004988',
                disabled: "#5b535d", //'#004988',
                contrastText: "#FFFFFF",
            },
            neutral: {
                main: "#64748B",
                contrastText: "#fff",
                dark: "#2D2D2D",
            },
            reusable: {
                main: "#86198F",
                light: "#FFF9FF",
            },

            // primary: {
            //     light: lightBlue[700],
            //     main: lightBlue[500],
            //     dark: lightBlue[200],
            //     contrastText: '#FFFFFF',
            // },
            // primary: {
            //     light: lime[700],
            //     main: lime[500],
            //     dark: lime[200],
            //     contrastText: '#FFFFFF',
            // },
            // primary: {
            //     light: '#6de5ff',
            //     main: '#21b3e8',
            //     dark: '#0083b6',
            //     contrastText: '#FFFFFF',
            // },
            // secondary: {
            //     light: teal[700],
            //     main: teal[500],
            //     dark: teal[200],
            //     contrastText: '#FFFFFF',
            // },
            // secondary: {
            //     light: '#71a2eb',
            //     main: '#3b74b8',
            //     dark: '#004988',
            //     contrastText: '#FFFFFF',
            // },
            // success: {
            //     light: lightGreen[700],
            //     main: lightGreen[500],
            //     dark: lightGreen[200],
            //     contrastText: '#FFFFFF',
            // },
        },
    });
};

export default Palette;
